// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/users/sms_subscription_groups_for_filter" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { usersSmsSubscriptionGroupsForFilter } from "./constants";
import type { UsersSmsSubscriptionGroupsForFilterResult } from "./types";

export const getUsersSmsSubscriptionGroupsForFilter = reactQueryFetcherAdapter(
  usersSmsSubscriptionGroupsForFilter,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit: number,
    filterKey?: string
  ): Promise<UsersSmsSubscriptionGroupsForFilterResult> => {
    return fetch(
      "/users/sms_subscription_groups_for_filter",
      "GET",
      { app_group_id: appGroupId, query, limit, filter_key: filterKey },
      { signal }
    );
  }
);
